import { useBreadcrumbs } from '@textile-erp/ui';
import { PendingApprovalsNotificationBell } from '../../components/PendingApprovalsNotificationBell';

interface HeaderProps {
  user: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    roles?: { name: string }[];
  };
}

export function Header({ user: _user }: HeaderProps) {
  const breadcrumbs = useBreadcrumbs();

  return (
    <header className="flex-shrink-0 bg-theme-primary/80 backdrop-blur-lg shadow-lg border-b border-theme-primary/20 animate-fadeInDown transition-all duration-300 hover:shadow-xl">
      <div className="px-4 sm:px-6 lg:px-8 py-1">
        <div className="flex items-center justify-between min-h-[28px]">

          {/* Breadcrumbs */}
          <nav className="flex" aria-label="Breadcrumb">
            {breadcrumbs.length > 0 ? (
              <ol className="inline-flex items-center space-x-1 md:space-x-2">
                {breadcrumbs.map((crumb, index) => (
                  <li key={index} className="inline-flex items-center">
                    {index > 0 && (
                      <svg className="w-3.5 h-3.5 text-theme-tertiary mx-1" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                      </svg>
                    )}
                    {(crumb.href || crumb.onClick) ? (
                      <a
                        href={crumb.href}
                        onClick={(e) => {
                          if (crumb.onClick) { e.preventDefault(); crumb.onClick(); }
                        }}
                        className="text-sm font-medium text-theme-secondary hover:text-theme-primary cursor-pointer transition-colors"
                      >
                        {crumb.label}
                      </a>
                    ) : (
                      <span className="text-sm font-medium text-theme-primary">
                        {crumb.label}
                      </span>
                    )}
                  </li>
                ))}
              </ol>
            ) : (
              <span className="text-sm font-semibold text-theme-primary">Hyatt</span>
            )}
          </nav>

          {/* Right side actions */}
          <div className="flex items-center space-x-2">
            <PendingApprovalsNotificationBell />
          </div>
        </div>
      </div>
    </header>
  );
}
